import { Box } from "@material-ui/core";
import { useEffect, useState } from "react";
import Axios from "axios";
import { Loading } from "../../components/shared/loading";
import { Helmet } from "react-helmet";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { useAdminStyles } from "../../components/admin/adminStyles";
import { AdminPageHeader } from "../../components/admin/AdminPageHeader";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";
const $ = require("jquery");

export const EnrolledStudents = () => {
  const classes = useAdminStyles();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    Axios.post("/api/get_all_students", { headers: { headKey: headKey } }).then(
      (res) => {
        setData(res.data.data || []);
        setLoading(false);
        $(document).ready(function () {
          $("#students_table").DataTable({
            destroy: true,
            scrollX: true,
          });
        });
      }
    );
  }, []);

  if (loading) return <Loading />;

  return (
    <div>
      <Helmet>
        <title>Enrolled Students - Admin | Arawinz Soft Solutions</title>
      </Helmet>

      <AdminPageHeader
        eyebrow="Records"
        title="Enrolled Students"
        subtitle={`Total enrolled: ${data.length}`}
      />

      <Box className={classes.tableWrap}>
        <table id="students_table" className="display" style={{ width: "100%" }}>
          <thead>
            <tr>
              <th>ID</th>
              <th>Reg No</th>
              <th>Name</th>
              <th>College</th>
              <th>Branch</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Enrolled</th>
            </tr>
          </thead>
          <tbody>
            {data.map((da) => (
              <tr key={da.student_id}>
                <td>{da.student_id}</td>
                <td style={{ fontWeight: 600 }}>{da.student_regno}</td>
                <td>{da.student_name}</td>
                <td>{da.student_college}</td>
                <td>{da.student_branch}</td>
                <td>{da.student_email}</td>
                <td>{da.student_mobile}</td>
                <td>{da.submitted_datetime}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
    </div>
  );
};
